import React, { useState, useEffect } from "react";
import T from "./TheTool";
import Timer from "./TheTimer";
import Template from "./TheTemplate";
import GUIset_2Input from "./gui/GUIset_2Input";

const LCS = () => {
	useEffect(() => {
		document.title = "Longest Common Subsequence (LCS) problem";
	}, []);
	const [guiTxt1, guiTxtChange1] = useState("BATSSCXCKZCET"); //int
	const [guiTxt2, guiTxtChange2] = useState("ABSAADSZKEDAKEDAT");
	//----
	const [partResult, partResultChange] = useState(<div></div>); //bottom part that show result

	const buttonClick1 = () => {
		if (guiTxt1 != "" && guiTxt2 != "") {
			Timer.setTimeBudget(4999);
			Timer.start();
			process(guiTxt1, guiTxt2);
			txt_time = Timer.stop_print();
			BuildResult();
			map = []; 
		}
	};

	var txt_time = "";
	var map = []; // String[][] map;//memory
	var txt_result = "";

	//longestCommonSubsequence
	function process(s1, s2) {
		map = T.getMatrix(guiTxt1.length + 1, guiTxt2.length + 1, "");
		txt_result = lCS(s1, s2);
	}

	function lCS(s1, s2) {
		// if (Timer.timeout()) {
		var s1_size = s1.length - 1; //last character
		var s2_size = s2.length - 1; //last character
		var result = map[s1.length][s2.length];
		// console.log("AAAAA " + s1 + "_" + s2 + " *** " + result);
		if (result == "") {
			if (s1_size < 0 || s2_size < 0) {
				result = "";
			} else if (s1.substring(s1_size) == s2.substring(s2_size)) {
				//The last characters are equal, compare "string before the last one"
				result =
					lCS(s1.substring(0, s1_size), s2.substring(0, s2_size)) +
					s1.substring(s1_size);
			} else {
				var first = lCS(s1, s2.substring(0, s2_size)); //s1 & s2 before the last one
				var second = lCS(s1.substring(0, s1_size), s2);
				if (first.length > second.length) {
					result = first;
				} else {
					result = second;
				}
			}
			map[s1.length][s2.length] = result;
		}
		return result;
	}
	//-------------------------

	function BuildResult() {
		var txt1 = "\nLength: " + txt_result.length;
		var txt2 = txt_result + " is the LCS, or one of them.";
		partResultChange(Template.simple4size("key2","Result",txt2,txt1,txt_time,28,24,20,18));
	}

	return (
		<GUIset_2Input
			title={"Longest Common Subsequence (LCS)"}
			desc={
				"Finding the longest subsequence common to all sequences in a set of sequences"
			}
			guiTxtChange1={guiTxtChange1}
			guiTxtChange2={guiTxtChange2}
			buttonClick1={buttonClick1}
			partResult={partResult}
			//------
			label1={"String1"}
			label2={"String2"}
			guiTxt1={guiTxt1}
			guiTxt2={guiTxt2}
			numberOnly1={false}
			numberOnly2={false}
			txtButton={"Calculate"}
		/>
	);
};

export default LCS;



// import GUI_Header from "./gui/GUI_Header";
// import GUI_InputTextSingle from "./gui/GUI_InputTextSingle";
// import GUI_Credit from "./gui/GUI_Credit";
// import T from "./TheTool";// NOT WORK, old ver


// return (
// 	<div className="todoapp stack-large">
// 		<GUI_Header
// 			title={"Longest Common Subsequence (LCS)"}
// 			desc={
// 				"Finding the longest subsequence common to all sequences in a set of sequences"
// 			}
// 		/>
// 		<div style={{ marginTop: "3em" }}> </div>
// 		<GUI_InputTextSingle
// 			label={"String1"}
// 			labelsize={22}
// 			text1={guiTxt1}
// 			text1Change={guiTxtChange1}
// 			numberOnly={false}
// 			width1={120}
// 			fontSize2={22}
// 			width2={"80%"}
// 		/>
// 		<GUI_InputTextSingle
// 			label={"String2"}
// 			labelsize={22}
// 			text1={guiTxt2}
// 			text1Change={guiTxtChange2}
// 			numberOnly={false}
// 			width1={120}
// 			fontSize2={22}
// 			width2={"80%"}
// 		/>
// 		<div style={{ display: "flex", marginLeft: "16%", marginRight: 0 }}>
// 			<button
// 				onClick={() => buttonClick1()}
// 				className="btn btn__primary btn__lg"
// 				style={{ flex: 1, height: 50 }}
// 			>
// 				Calculate
// 			</button>
// 		</div>
// 		<div style={{ marginTop: "3em" }}> </div>
// 		{partResult}
// 		{/* {GetResult()} */}
// 		<GUI_Credit />
// 	</div>
// );



	// //longestCommonSubsequence
	// function process(s1, s2) {
	// 	//row, col
	// 	// map = new String[s1.length() + 1][s2.length() + 1];
	// 	// for(int a = 0; a < map.length;a++) {Arrays.fill(map[a],"");}
	// 	// map = new Array(s1.length + 1)
	// 	// 	.fill("")
	// 	// 	.map(() => new Array(s2.length + 1).fill(""));
	// 	map = T.getMatrix(s1.length + 1, s2.length + 1, "");
	// 	txt_result = lCS(s1, s2);
	// 	// console.log("Result " + result);
	// }

	// function lCS(s1, s2) {
	// 	// if (Timer.timeout()) {
	// 	// 	return;
	// 	// } //Check time out first
	// 	//-------------------------------
	// 	var s1_size = s1.length - 1; //last character
	// 	var s2_size = s2.length - 1; //last character
	// 	var result = map[s1.length][s2.length];
	// 	// console.log("AAAAA " + s1 + "_" + s2 + " *** " + result);
	// 	if (result == "") {
	// 		if (s1_size < 0 || s2_size < 0) {
	// 			result = "";
	// 		} else if (s1.substring(s1_size) == s2.substring(s2_size)) {
	// 			//The last characters are equal, compare "string before the last one"
	// 			result =
	// 				lCS(s1.substring(0, s1_size), s2.substring(0, s2_size)) +
	// 				s1.substring(s1_size);
	// 		} else {
	// 			var first = lCS(s1, s2.substring(0, s2_size)); //s1 & s2 before the last one
	// 			var second = lCS(s1.substring(0, s1_size), s2);
	// 			if (first.length > second.length) {
	// 				result = first;
	// 			} else {
	// 				result = second;
	// 			}
	// 		}
	// 		map[s1.length][s2.length] = result;
	// 	}
	// 	return result;
	// }



	//oth ver -----------------------
	// function lSC(s1, s2) {
	//     var s1_size = s1.length - 1;//last character
	//     var s2_size = s2.length - 1;//last character
	//     if (s1_size < 0 || s2_size < 0) { return ""; }
	//     else if (s1.substring(s1_size).equals(s2.substring(s2_size))) {//The last characters match"
	//         return lSC(s1.substring(0, s1_size), s2.substring(0, s2_size)) + s1.substring(s1_size);// "find the rest before the last character" + "print last character"
	//     }
	//     else {//last character not match, try remove the last characters >> both remove s1 and s2, and select the longer after get result
	//         var first = lSC(s1, s2.substring(0, s2_size));//s1 & s2 before the last one
	//         var second = lSC(s1.substring(0, s1_size), s2);
	//         if (first.length() > second.length()) {
	//             return first;
	//         } else {
	//             return second;
	//         }
	//     }
	// }



	// function BuildResult() {
	// 	var txt1 = "\nLength: " + txt_result.length;
		// partResultChange(
		// 	<div>
		// 		{/* <div className="flexbox-container"> */}
		// 		<div style={{ whiteSpace: "pre-line", fontSize: 26, paddingRight: 20 }}>
		// 			<b>Result</b>
		// 		</div>
		// 		<div style={{ whiteSpace: "pre-line", fontSize: 24 }}>{txt_result}</div>
		// 		<br />
		// 		<div
		// 			style={{ whiteSpace: "pre-line", fontSize: 20, alignItems: "left" }}
		// 		>
		// 			{txt1}
		// 		</div>
		// 		{txt_time}
		// 	</div>
		// );
	// }